import { render, staticRenderFns } from "./rolesys.vue?vue&type=template&id=7f992d6c&"
import script from "./rolesys.vue?vue&type=script&lang=js&"
export * from "./rolesys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports